import React from 'react';
import NotAuth from '../../Dashboard/NoRoute/notAuth';

const NotAuthorized = () => (
  <NotAuth />
);

export default NotAuthorized;
